import type {StagedRecord} from './types';

/**
 * Orders staged records by name. Shared by the shelf (`buildStagedShelfTree`) and advancement
 * (`resolveBundleMember`) so the visible order and the "approve one → open the next" order
 * can never drift apart.
 */
export const byStagedName = (a: StagedRecord, b: StagedRecord): number =>
  (a.name ?? '').localeCompare(b.name ?? '');
